import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

import {TagInformation} from "../../../../model/tag-information";
import {EntityLine} from "../../../../entity/entity-line";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {DialogService} from "../../../../services/dialog.service";

@Component({
    selector: 'app-clm-product-line-header',
    imports: [FormsModule, MatButton, MatIcon],
    templateUrl: './clm-product-line-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-product-line-header.component.css'
})
export class ClmProductLineHeaderComponent implements OnChanges {
  private readonly userStateService = inject(UserStateService);
  private readonly dialogService = inject(DialogService);
  readonly tags = input.required<TagInformation[]>();
  readonly lineInput = input.required<EntityLine>({ alias: 'line' });
  readonly isOem = input.required<boolean>();
  readonly quantityChanged = output<void>();
  readonly tagInformationUpdated = output<TagInformation[]>();
  isExpanded = true;
  private sectionKey = ConfigurationSection.LINE_HEADER_INFORMATION;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
  }

  invalidTags(): boolean {
    return this.lineInput() && this.tags() && this.lineInput().quantityExtended !== this.tags().length;
  }

  showTagsDialog(): void {
    this.dialogService.showTagManagementDialog(this.tags() || [], 640, this.lineInput().quantityExtended, false).subscribe({
      next: (result: TagInformation[]) => {
        if (result && result.length > 0) {
          this.tagInformationUpdated.emit(result);
        }
      }
    });
  }

  updateQuantity(): void {
    this.quantityChanged.emit();
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

}
